import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-panel',
  standalone: true,
  template: `
  <div class="pl-4 pr-4 border border-gray-200 rounded-lg shadow mb-10">
    <div class="bg-gray-300 -ml-3.5 -mr-3.5 mb-5 p-1 rounded-sm">
        <h3 class="ml-2 text-xl font-medium text-gray-900 dark:text-white">{{ props.label }}</h3>
    </div>
    <div>
      <ng-container #fieldComponent></ng-container>
    </div>
</div>
  `
})
export class PanelWrapperComponent extends FieldWrapper {}